import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import PreviewAssignment from './PreviewAssignment';

const PreviewAssignmentWrapper = props => {
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  return (
    <PreviewAssignment
      {...props}
      printRef={contentRef}
      handlePrint={handlePrint}
    />
  );
};

export default PreviewAssignmentWrapper;
